import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { AchievementsSection } from '../components/AchievementsSection';
import { ServicesSection } from '../components/ServicesSection';
import { NichesSection } from '../components/NichesSection';
import { ProcessSteps } from '../components/ProcessSteps';
import { AdvantagesSection } from '../components/AdvantagesSection';
import { CeoSection } from '../components/CeoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-white" data-id="element-815">
      <Header data-id="element-816" />
      <main data-id="element-817">
        <HeroSection data-id="element-818" />
        <AchievementsSection data-id="element-819" />
        <ServicesSection data-id="element-820" />
        <NichesSection data-id="element-821" />
        <ProcessSteps data-id="element-822" />
        <AdvantagesSection data-id="element-823" />
        <CeoSection data-id="element-824" />
        <TestimonialsSection data-id="element-825" />
        <ContactForm data-id="element-826" />
      </main>
      <Footer data-id="element-827" />
    </div>;
}